module.exports = __webpack_public_path__ + "img/hero-accents.1c5613e8.png";